import type { GenericError, JsonListenResponse, RequestStatus } from '@skynet/data-ws-core';
import type { IsoDateString } from '@skynet/formatting-date';
import type { TaskStatus } from '@skynet/types-task-status';

export enum ArbitrageCommands {
  Arbitrage = 'Arbitrage',
  ArbitrageAccounts = 'ArbitrageAccounts',
}

export interface JsonArbitrage {
  id: number;
  pair: string;
  match: string;
  accountsTotal: number;
  accountsActive: number;
  spread: number;
  buyPrice: number;
  sellPrice: number;
  volume24: number;
  volume: number;
  disbalance: number;
  profit: number;
  status: string;
  bestBuyPrice: number;
  bestSellPrice: number;
  maxSpread: number;
  bestMatch: string;
  lastTradeTime: IsoDateString;
  startSpread: number;
  spreadLimit: number;
}

export type JsonArbitrageSuccess = JsonListenResponse<
  ArbitrageCommands.Arbitrage,
  {
    list: JsonArbitrage[];
  }
>;

export interface JsonArbitrageTask {
  taskID: number;
  ticker: string;
  status: TaskStatus;
}

export interface JsonArbitrageAccount {
  exchangeID: number;
  accountTitle: string;
  accountID: number;
  recommendation: string;
  baseAmountTokens: number;
  quoteAmountTokens: number;
  baseToken: string;
  quoteToken: string;
  baseAmountUSD: number;
  quoteAmountUSD: number;
  baseQuoteRatio: number;
  marketVolume24: number;
  marketVolumeMonthly: number;
  ourVolume24: number;
  ourVolumeMonthly: number;
  buyPrice: number;
  originalBuyPrice: number;
  sellPrice: number;
  originalSellPrice: number;
  arbitrageTasks: JsonArbitrageTask[];
  lastTradeTime: IsoDateString;
}

export interface JsonArbitrageAccountsJson {
  id: number;
  accounts: JsonArbitrageAccount[];
}

export type JsonArbitrageAccountsSuccess = JsonListenResponse<
  ArbitrageCommands.ArbitrageAccounts,
  JsonArbitrageAccountsJson
>;

export interface ArbitrageState {
  list: JsonArbitrage[];
  details: Record<number, JsonArbitrageAccount[]> | null;
  error: GenericError | null;
  requestStatus: RequestStatus;
}
